<template>
  <div class="box" v-if="previousRoute" @click="redirect">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.9728 1.28576C24.5707 1.87771 24.5707 2.83746 23.9728 3.42941L11.2755 15.9997L23.9728 28.57C24.5707 29.1619 24.5707 30.1217 23.9728 30.7136C23.3748 31.3056 22.4054 31.3056 21.8075 30.7136L8.02755 17.0715C7.42962 16.4796 7.42962 15.5198 8.02755 14.9279L21.8075 1.28576C22.4054 0.693809 23.3748 0.693809 23.9728 1.28576Z"
        fill="#090741"
      />
    </svg>

    <p>Wstecz</p>
  </div>
</template>

<script>
export default {
  name: "BackButton",
  methods: {
    redirect() {
      const lastRoute = JSON.parse(this.previousRoute);
      this.$router.push({
        name: lastRoute.name,
        params: lastRoute.params,
        query: lastRoute.query,
      });
    },
  },
  computed: {
    previousRoute() {
      return window.sessionStorage.getItem("dodLastRoute");
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  gap: 2rem;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
  width: fit-content;
  height: 40px;
}
</style>